import i18n from "i18next";
import ja from "./ja";

i18n.init({
  resources: {
    ja: { translation: ja },
  },
  lng: "ja",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
